export const MAX_DISPLAYED_PAGES_AMOUNT = 8;
export const MAX_DISPLAYED_PAGES_AMOUNT_MOBILE = 4;
